'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _titleSection = require('./common/title-section');

var _titleSection2 = _interopRequireDefault(_titleSection);

var _bodySection = require('./common/body-section');

var _bodySection2 = _interopRequireDefault(_bodySection);

var _ctaSection = require('./common/cta-section');

var _ctaSection2 = _interopRequireDefault(_ctaSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = _react2['default'].createClass({
    displayName: 'Automate Workflow SEO Page',

    renderTitleSection: function renderTitleSection() {
        var titleSectionProps = {
            title: 'Using Online Digital Signatures to Sign Documents',
            subtitle: 'Create a HelloSign account to start signing now.',
            buttonText: 'Create My Free Account!'
        };
        return _react2['default'].createElement(_titleSection2['default'], _extends({}, titleSectionProps, this.props));
    },

    renderBodySection: function renderBodySection() {
        var headerClass = 'm-marketing-page--header';
        var listClass = 'm-marketing-page--list';
        return _jsx(_bodySection2['default'], {}, void 0, _jsx('h2', {
            className: headerClass
        }, void 0, 'Can I use HelloSign to automate my paperwork?'), _jsx('p', {}, void 0, 'Yes! HelloSign enables users to automate paperwork and workflows through features like our automatic email reminders and the “Insert Everywhere” option which helps completes long paperwork quickly.  Features like these make it easy to follow-up on paperwork and streamline the signing process.'), _jsx('h2', {
            className: headerClass
        }, void 0, 'Why automate a workflow?'), _jsx('p', {}, void 0, 'Imagine the next document that you need to get signed. Have one in mind? Traditionally, it might take you one or two days to get the signature you need. It’d likely require printing, signing, and faxing. By automating the paperwork flow with eSignatures, you can shrink the signing process down to just a few minutes and clicks.'), _jsx('p', {}, void 0, 'Not only does automating your workflow save you time and paper, it saves productive hours and resources.'), _jsx('h2', {
            className: headerClass
        }, void 0, 'What kind of workflows can I streamline using eSignatures?'), _jsx('p', {}, void 0, 'All different types of workflows can be streamlined using eSignatures. For example:'), _jsx('ul', {
            className: listClass
        }, void 0, _jsx('li', {}, void 0, 'Real estate agents can close deals onsite by having their clients sign paperwork on tablets or other mobile devices.'), _jsx('li', {}, void 0, 'Schools can automate the registration process by having their students sign online applications with legally-binding eSignatures.'), _jsx('li', {}, void 0, 'Sales teams seal can contracts faster by merging data from their CRM systems into online document templates. Psst… ', _jsx('a', {
            href: 'http://blog.hellosign.com/hellosign-and-hubspot-join-forces/',
            target: '_blank'
        }, void 0, 'Check out how users are using the HelloSign + HubSpot integration to automate their sales document workflow'), '.')), _jsx('p', {}, void 0, 'That’s not all! You can ', _jsx('a', {
            target: '_blank',
            href: 'http://blog.hellosign.com/category/general/customer-stories/'
        }, void 0, 'read more about the different use cases here'), '.'), _jsx('h2', {
            className: headerClass
        }, void 0, 'How do HelloSign electronic signatures work?'), _jsx('p', {}, void 0, 'HelloSign makes it easy to electronically sign documents, send signature requests to others, and track where your documents are at all times. Here are just of few of the features that make it easy to automate your workflow:'), _jsx('ul', {
            className: listClass
        }, void 0, _jsx('li', {}, void 0, _jsx('strong', {}, void 0, 'Automatic email reminders.'), ' You’ll get a notification each and every time someone signs your document. This removes the need keep track of each eSignature and the possibility of misplaced documents.'), _jsx('li', {}, void 0, _jsx('strong', {}, void 0, 'Audit trails.'), ' Each signing activity is recorded for each document. These audit trails help you to automatically store important signer information in one location.'), _jsx('li', {}, void 0, _jsx('strong', {}, void 0, '“Insert Everywhere” option.'), ' When signing a lengthy document, you may have multiple spots for signature and initials. The “Insert Everywhere” option makes it possible for signers to automate the signing process by inserting their signature into all the required signature fields. Learn more about this feature and our signing experience here.  ', _jsx('a', {
            target: '_blank',
            href: 'http://blog.hellosign.com/new-signer-experience/'
        }, void 0, 'Learn more about this feature and our signing experience here.'))), _jsx('h2', {
            className: headerClass
        }, void 0, 'What are some other ways to use HelloSign?'), _jsx('p', {}, void 0, 'You can enable some of our partner integrations for an even smoother document workflow. Want to sign from your email account? No problem. Sign a document stored in Dropbox? A-OK.'), _jsx('p', {}, void 0, 'Here are just a few examples of our favorite integrations:'), _jsx('ul', {
            className: listClass
        }, void 0, _jsx('li', {}, void 0, 'Google (including ', _jsx('a', {
            href: 'https://www.hellosign.com/gmail',
            target: '_blank'
        }, void 0, 'Gmail'), ', ', _jsx('a', {
            href: 'https://www.hellosign.com/googledrive',
            target: '_blank'
        }, void 0, 'Google Drive'), ', and ', _jsx('a', {
            href: 'https://www.hellosign.com/google-docs-add-on',
            target: '_blank'
        }, void 0, 'Google Docs'), ')'), _jsx('li', {}, void 0, _jsx('a', {
            href: 'http://blog.hellosign.com/hellosign-integrates-with-evernote/',
            target: '_blank'
        }, void 0, 'Evernote')), _jsx('li', {}, void 0, _jsx('a', {
            href: 'http://blog.hellosign.com/dropbox/',
            target: '_blank'
        }, void 0, 'Dropbox')), _jsx('li', {}, void 0, _jsx('a', {
            href: 'http://blog.hellosign.com/hellosign-launches-integration-with-slack/',
            target: '_blank'
        }, void 0, 'Slack')), _jsx('li', {}, void 0, 'Zapier'), _jsx('li', {}, void 0, _jsx('a', {
            href: 'http://blog.hellosign.com/hellosign-and-hubspot-join-forces/',
            target: '_blank'
        }, void 0, 'HubSpot CRM'))));
    },

    renderCTASection: function renderCTASection() {
        var ctaSectionProps = {
            title: 'Get Started',
            subtitle: 'Document automation reduces loss of time, loss of resources, and loss of mental bandwidth. Gain back the loss by automating! We’re happy to get you  started.',
            signupButtonText: 'CREATE A FREE HELLOSIGN ACCOUNT',
            signupButtonUrl: this.props.homeUrl,
            secondButtonText: 'SEE PRO PLANS',
            secondButtonUrl: this.props.pricingUrl
        };
        return _react2['default'].createElement(_ctaSection2['default'], _extends({}, ctaSectionProps, this.props));
    },

    render: function render() {
        return _jsx('div', {}, void 0, this.renderTitleSection(), this.renderBodySection(), this.renderCTASection());
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/automate-workflow.jsx
 ** module id = 819
 ** module chunks = 0
 **/